import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  direction: rtl;
`;

export const Title = styled.div`
  font-size: 22pt;
  font-weight: bold;
  color: #404041;
  height: 9vh;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const NavAndBackContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
